import { useSectionId, useMainContainerMinMargins } from '@v4/components/common/SectionItem'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import { useMediaQuery, useTheme } from '@material-ui/core'
import useStyles from './Cta10.styled'

export const useCta10 = props => {
	const { metaData } = props
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

	const minMargins = useMainContainerMinMargins()
	const classes = useStyles({ ...props, isMobile, minMargins })

	const sectionId = useSectionId()

	const items = PageBuilderSelector.useRepeatableGroupKeys({
		sectionId,
		group: 'items',
	})

	const columnsNumber = Math.min(metaData.columns?.toNumber(), _.size(items))

	const maxWidth = columnsNumber === 1 ? 'sm' : 'lg'

	return [
		{
			classes,
			maxWidth,
			items,
			columnsNumber,
			isMobile,
			mobileButtonWidth: metaData.mobileButtonWidth,
			mobileContentAlignment: metaData.mobileContentAlignment,
		},
	]
}
